import ErrorNLoadging from './ErrorNLoading';
import Loading from './Loading';
import Error from './Error';
import Login from './Login';
import FileUpload from './FileUpload';

import Presentation from './Presentation';
const presentation = new Presentation();

const store = {
  ...ErrorNLoadging,
  presentation,
  loginInfo:new Login(),
  fileUpload :new FileUpload()
};

export default store;